module.exports = __webpack_public_path__ + "img/facebook.b8377357.svg";